// ADA Mobile Menu

var openButton, closeButton;
var modal, menuContainer, menuLevel0, menuLevel1, menuLevel2;
var menuIsOpen = false;
var firstFocusableElement, lastFocusableElement;

document.addEventListener('DOMContentLoaded', function (e) {
  menuContainer = document.querySelector('.menu-container');
  openButton = document.querySelector('.c-menu-btn');
  closeButton = document.querySelector('.close-button');
  modal = document.querySelector('#mobile-menu-modal');
  menuLevel0 = modal.querySelector('.menu-level-0');
  menuLevel1 = modal.querySelector('.menu-level-1');
  menuLevel2 = modal.querySelector('.menu-level-2');
  firstFocusableElement = closeButton;
  lastFocusableElement = menuLevel0.querySelector('.last-focusable-element');

  // Show and move focus into the mobile menu when the hamburger icon button is activated
  openButton.addEventListener('click', function (e) {

    $(modal).show();
    $('body').addClass('menu-active');

    $(menuContainer).animate({ width: 250 }, function () {
      closeButton.focus();
      menuIsOpen = true;
    });

    $(closeButton).animate({ left: 250 });
  });

  // Hide the mobile menu and move focus back to the hamburger icon button when the close button is activated
  closeButton.addEventListener('click', function (e) {
    closeMenu();
    $('body').removeClass('menu-active');
  });

  // Slide into a submenu whenever a top-level button is activated
  menuLevel0.querySelectorAll('button').forEach(function (button) {
    button.addEventListener('click', function () {
      // Make the target menu visible, then slide it into view
      var targetMenu = document.getElementById(button.getAttribute('aria-controls'));
      $(targetMenu).css('display', 'block');
      $(menuLevel1).animate({ left: 0 }, function () {
        lastFocusableElement = targetMenu.querySelector('.last-focusable-element');
        targetMenu.querySelector('.back-button').focus();
      });

      // Slide the level 0 menu out of the way, then hide it from all users
      $(menuLevel0).animate({ left: -250 }, function () {
        $(menuLevel0).css('display', 'none');
      });
    });
  });

  // Slide into a submenu whenever a second-level button is activated
  menuLevel1.querySelectorAll('button').forEach(function (button) {
    if (!button.classList.contains('back-button')) {

      button.addEventListener('click', function () {
        // Make the target menu visible, then slide it into view
        var targetMenu = document.getElementById(button.getAttribute('aria-controls'));
        $(targetMenu).css('display', 'block');

        if (menuLevel2 != null) {
          $(menuLevel2).animate({ left: 0 }, function () {
            lastFocusableElement = targetMenu.querySelector('.last-focusable-element');
            targetMenu.querySelector('.back-button').focus();
          });
        }

        // Slide the level 1 menu out of the way, then hide it from all users
        $(menuLevel1).animate({ left: -250 }, function () {
          $(menuLevel1).css('display', 'none');
        });

      });
    }
  });

  // Slide back to the levl 0 menu when a "back" button is activated
  menuLevel1.querySelectorAll('.ada-menu .back-button').forEach(function (backButton) {
    backButton.addEventListener('click', function () {
      // Slide the level 1 menu out of the way, then hide it from all users
      $(menuLevel1).animate({ left: 250 }, function () {
        $(backButton).closest('.ada-menu').css('display', 'none');
      });

      // Make the level 0 menu visible, then slide it into view
      $(menuLevel0).show().animate({ left: 0 }, function () {
        lastFocusableElement = menuLevel0.querySelector('.last-focusable-element');
        menuLevel0.querySelector('ul li:first-of-type a').focus();
      });
    });
  });

  if (menuLevel2 != null) {
    // Slide back to the levl 1 menu when a level 2 "back" button is activated
    menuLevel2.querySelectorAll('.ada-menu .back-button').forEach(function (backButton) {
      backButton.addEventListener('click', function () {
        // Slide the level 2 menu out of the way, then hide it from all users
        $(menuLevel2).animate({ left: 250 }, function () {
          $(backButton).closest('.ada-menu').css('display', 'none');
        });

        // Make the level1 target menu visible, then slide it into view
        var targetMenu = document.getElementById(backButton.getAttribute('data-parentid'));
        $(targetMenu).css('display', 'block');
        $(menuLevel1).css('display', 'block');
        $(menuLevel1).show().animate({ left: 0 }, function () {
          lastFocusableElement = targetMenu.querySelector('.last-focusable-element');
          targetMenu.querySelector('.back-button').focus();
        });
      });
    });
  }

  // Trap keyboard focus inside the mobile menu
  modal.addEventListener('keydown', function (e) {
    if (menuIsOpen) {
      if (e.key == 'Tab') {
        // Forward tab wraps to the top
        if (!e.shiftKey) {
          if (document.activeElement == lastFocusableElement) {
            firstFocusableElement.focus();
            e.preventDefault();
          }
          // Backward tab wraps to the bottom
        } else {
          if (document.activeElement == firstFocusableElement) {
            lastFocusableElement.focus();
            e.preventDefault();
          }
        }
      }

      // Close the menu on Escape keypress
      if (e.key == 'Escape') {
        closeMenu();
      }
    }
  });
});

function closeMenu() {
  $(menuContainer).animate({ width: 0 }, function () {
    $(modal).css('display', 'none');
    openButton.focus();
    menuIsOpen = false;

    // Reset the menu back to the root level
    $(menuLevel1).css('left', '250px');
    menuLevel1.querySelectorAll('.ada-menu').forEach(function (menu) {
      $(menu).css('display', 'none');
    });

    $(menuLevel0).css('display', 'block');
    $(menuLevel0).css('left', '0');
  });

  $(closeButton).animate({ left: 0 });
}
